import { render } from "./columnsList.vue?vue&type=template&id=38a39165"
import script from "./columnsList.vue?vue&type=script&lang=js"
export * from "./columnsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__